import { useState } from "react";
import { useHistory } from "react-router-dom";
import Sidebar from "@/pages/sidebar/sidebar";
import { CreditCard, SlidersHorizontal, LayoutList } from "lucide-react";

// TODO: Replace with real Deluxe info URL
const DELUXE_INFO_URL = "#";
const SUPPORT_EMAIL = "support@pocketbook.tech";

const benefits = [
  {
    icon: CreditCard,
    title: "Your customers can pay via credit or debit card",
    description:
      "Accept card payments directly from your customers at time of payment.",
  },
  {
    icon: SlidersHorizontal,
    title: "Customize your payment method",
    description:
      "Only want to offer credit card for certain payments? No problem. Simply turn the option off when creating an invoice or turn them off by default.",
  },
  {
    icon: LayoutList,
    title: "Track your payments",
    description:
      "See all customer card payments in one spot. Just go to Get Paid > Customer Payments to track and manage activity.",
  },
];

const MerchantProcessingLanding = () => {
  const history = useHistory();
  const [currentWidth, setCurrentWidth] = useState(0);

  return (
    <div className="min-h-screen">
      <Sidebar currentWidth={currentWidth} setCurrentWidth={setCurrentWidth} />
      <div className="relative min-h-screen overflow-auto lg:ml-80 bg-[#f8f8f8]">
        <div className="min-h-screen flex items-center px-4 md:px-6 xl:px-12 py-8">
          <div className="flex flex-col lg:hidden w-full max-w-xl mx-auto gap-6">
            <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm flex flex-col gap-5">
              <div>
                <h2 className="text-2xl font-bold text-gray-900 leading-snug">
                  Merchant Processing: Your customers are dynamic, your payments
                  should be too
                </h2>
                <p className="mt-3 text-base font-medium leading-relaxed text-gray-700">
                  We've partnered with{" "}
                  <a
                    href={DELUXE_INFO_URL}
                    target="_blank"
                    rel="noreferrer"
                    className="font-bold underline text-gray-900 hover:text-gray-900"
                  >
                    Deluxe
                  </a>{" "}
                  to make card payment processing available to you.
                </p>
                <p className="mt-4 text-base font-bold text-gray-900">
                  Here's how the application process works:
                </p>
                <ul className="mt-2 space-y-2">
                  {[
                    "We'll walk you through some additional information needed to apply for card payment processing.",
                    <>
                      The business and personal information you have shared with
                      us will be included in the application. So if it's
                      changed, please{" "}
                      <a
                        href={`mailto:${SUPPORT_EMAIL}`}
                        className="underline font-semibold text-gray-900 hover:text-gray-900"
                      >
                        contact us
                      </a>{" "}
                      before starting!
                    </>,
                    "You'll need to read and accept the Merchants Terms and Conditions with our merchant processing provider, Deluxe.",
                    "In some situations, we may need to request more information. We will reach out to you if needed.",
                    "Applications take 1-2 days to process and you'll receive an email once that's complete or if we need more information.",
                  ].map((item, i) => (
                    <li
                      key={i}
                      className="flex items-baseline gap-2.5 text-base font-medium text-gray-700"
                    >
                      <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-gray-400" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex gap-3">
                <button
                  type="button"
                  onClick={() => history.push("/invoices")}
                  className="rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                >
                  Back to Get Paid
                </button>
                <button
                  type="button"
                  onClick={() => history.push("/invoices/settings/merchant/1")}
                  className="rounded-lg bg-skin-primary hover:opacity-90 px-4 py-2.5 text-sm font-semibold text-white transition-colors"
                >
                  Set Up Now
                </button>
              </div>
            </div>

            <div className="bg-skin-primary rounded-xl p-6 flex flex-col gap-6">
              {benefits.map(({ icon: Icon, title, description }) => (
                <div key={title} className="flex items-start gap-4">
                  <div className="shrink-0 rounded-md bg-white p-3">
                    <Icon className="h-7 w-7 text-gray-900" />
                  </div>
                  <div>
                    <p className="text-xl font-semibold text-white">{title}</p>
                    <p className="mt-1 text-lg text-gray-300 leading-relaxed">
                      {description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="hidden lg:flex min-h-[800px] w-full max-w-[1400px] items-center">
            {/* Left — content card */}
            <div className="bg-white p-8 flex flex-col justify-between w-[720px] max-w-[760px] rounded-xl border border-gray-200 shadow-sm -mr-24 z-10 min-h-[640px]">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 leading-snug">
                  Merchant Processing: Your customers are dynamic, your payments
                  should be too
                </h2>
                <p className="mt-3 text-base font-medium leading-relaxed text-gray-700">
                  We've partnered with{" "}
                  <a
                    href={DELUXE_INFO_URL}
                    target="_blank"
                    rel="noreferrer"
                    className="font-bold underline text-gray-900 hover:text-gray-900"
                  >
                    Deluxe
                  </a>{" "}
                  to make card payment processing available to you.
                </p>
                <p className="mt-4 text-base font-bold text-gray-900">
                  Here's how the application process works:
                </p>
                <ul className="mt-2 space-y-2">
                  {[
                    "We'll walk you through some additional information needed to apply for card payment processing.",
                    <>
                      The business and personal information you have shared with
                      us will be included in the application. So if it's
                      changed, please{" "}
                      <a
                        href={`mailto:${SUPPORT_EMAIL}`}
                        className="underline font-semibold text-gray-900 hover:text-gray-900"
                      >
                        contact us
                      </a>{" "}
                      before starting!
                    </>,
                    "You'll need to read and accept the Merchants Terms and Conditions with our merchant processing provider, Deluxe.",
                    "In some situations, we may need to request more information. We will reach out to you if needed.",
                    "Applications take 1-2 days to process and you'll receive an email once that's complete or if we need more information.",
                  ].map((item, i) => (
                    <li
                      key={i}
                      className="flex items-baseline gap-2.5 text-base font-medium text-gray-700"
                    >
                      <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-gray-400" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex gap-3 mt-6">
                <button
                  type="button"
                  onClick={() => history.push("/invoices")}
                  className="rounded-lg border border-gray-300 bg-white px-5 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                >
                  Back to Get Paid
                </button>
                <button
                  type="button"
                  onClick={() => history.push("/invoices/settings/merchant/1")}
                  className="rounded-lg bg-skin-primary hover:opacity-90 px-5 py-2.5 text-sm font-semibold text-white transition-colors"
                >
                  Set Up Now
                </button>
              </div>
            </div>

            <div className="bg-skin-primary w-[620px] self-stretch rounded-2xl border border-gray-800 shadow-sm pl-36 pr-16 py-12 flex flex-col justify-center gap-14">
              {benefits.map(({ icon: Icon, title, description }) => (
                <div key={title} className="flex items-start gap-4">
                  <div className="shrink-0 rounded-md bg-white p-3">
                    <Icon className="h-7 w-7 text-gray-900" />
                  </div>
                  <div>
                    <p className="text-xl font-semibold text-white">{title}</p>
                    <p className="mt-1 text-lg text-gray-300 leading-relaxed">
                      {description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MerchantProcessingLanding;
